/**
 * ReadOnlyProvider — flags the publisher dashboard as read-only (lapsed subscription).
 *
 * Purpose: a single boolean, set once by the route guard from access_state, that
 *          action controls (export, upload, create/edit/delete) read via
 *          useReadOnly() to disable themselves. Default false (full access).
 *
 * The context object lives in shared/hooks/useReadOnly (mirrors AuthContext) so
 * this file exports only the component.
 */
import { type ReactNode } from "react";
import { ReadOnlyContext } from "@/shared/hooks/useReadOnly";

interface ReadOnlyProviderProps {
  value: boolean;
  children: ReactNode;
}

export function ReadOnlyProvider({ value, children }: ReadOnlyProviderProps) {
  return <ReadOnlyContext.Provider value={value}>{children}</ReadOnlyContext.Provider>;
}
